// Auth context definitions
// Separate contexts for state and actions for optimal re-render performance

import { createContext } from "react";
import { User } from "./types";
import { TokensInfo } from "./auth-tokens";

/**
 * Auth state context
 * Provides current user and loading status
 */
export const AuthContext = createContext<
  | {
      user: User | null;
      isLoaded: boolean;
    }
  | undefined
>(undefined);

/**
 * Auth actions context
 * Provides auth-related actions (logout, setUser)
 * Separated from state to prevent unnecessary re-renders
 */
export const AuthActionsContext = createContext<
  | {
      setUser: (user: User | null) => void;
      logOut: () => Promise<void>;
    }
  | undefined
>(undefined);

/**
 * Auth tokens context
 * Provides token management actions
 * Separated for optimal re-render performance
 */
export const AuthTokensContext = createContext<
  | {
      setTokensInfo: (tokensInfo: TokensInfo | null) => void;
    }
  | undefined
>(undefined);
